import styled from 'styled-components';

import { colors } from 'config/theme';
export const ReferenceWrapper = styled.div`
  border: 1px solid ${colors.lightGray};
  background-color: #222222;
  color: white;
  border-radius: 5px;
  padding: 15px 40px;
  margin-top: 10px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
`;

export const ReferenceRow = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
`;
export const ReferenceColumn = styled.div`
  display: flex;
  flex-flow: column;
  width: 50%;
  overflow-wrap: break-word;
`;

export const ReferenceCellTextWrapper = styled.div`
  padding: 5px;
`;
export const ReferenceCellHeader = styled.span`
  font-size: 0.8rem;
  color: ${colors.darkGray};
`;
export const ReferenceCellValue = styled.span`
  font-size: 0.9rem;
  color: black;
  font-weight: 250;
`;
